import { render, staticRenderFns } from "./VecDynFileUploadDetail.vue?vue&type=template&id=8466cd90&scoped=true&"
import script from "./VecDynFileUploadDetail.vue?vue&type=script&lang=js&"
export * from "./VecDynFileUploadDetail.vue?vue&type=script&lang=js&"
import style0 from "./VecDynFileUploadDetail.vue?vue&type=style&index=0&id=8466cd90&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8466cd90",
  null
  
)

export default component.exports